






import Vue from "vue";
import ProductSlider from "@/components/ProductSlider.vue";
import { MagentoProduct } from "./lib/MagentoTypes";
declare const window: any;

export default Vue.extend({
  name: "App",
  components: {
    ProductSlider,
  },
  data() {
    return {
      products: [] as MagentoProduct[]
    }
  },
  methods: {
    async fetchExampleProducts() {
//      const dataElement = document.querySelector('data')
//      const results = await fetch(dataElement?.value ?? "https://vygon-api.cekom.de/products/favorite");
      const results = await fetch(window.loadMagentoProductsRoute ?? "https://vygon-api.cekom.de/products/favorite");

      const products = (await results.json()) as MagentoProduct[];
      // const productsArray = Object.entries(products).map((([_, product]) => product))
      if (Array.isArray(products)) {
      products.forEach((product) => {
        product.media_gallery_entries.sort((a, b) => {
          if (a.media_type === "image") {
            return -1;
          } else {
            return 1;
          }
        });
      });
      }

      return Array.isArray(products) ? products : [products];
    },
  },
  async mounted() {
    this.$store.dispatch("setUpMqls")
    try {
      this.products = await this.fetchExampleProducts();
    } catch (error) {
      console.error(error)
    }
  }
});
